var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow":"hidden"},style:({
    background:
      _vm.$route.path == '/report' ? '' : 'url(' + _vm.$images.background_bg + ')',
    backgroundSize: '100%',
  }),attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }